import React, { useMemo } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Alert,
  CircularProgress,
  Button,
  Chip,
  Divider,
  IconButton,
} from "@mui/material";
import {
  Refresh as RefreshIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import { FileIcon } from "../shared/FileIcon";

export const FolderList = ({
  folders,
  loading,
  error,
  onRefresh,
  onFolderClick,
  onSettingsClick,
  userRole,
}: any) => {
  const isAdmin = useMemo(() => {
    return userRole && (userRole === "admin" || userRole === "super-admin");
  }, [userRole]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert
        severity="error"
        sx={{ mt: 2 }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={onRefresh}
            startIcon={<RefreshIcon />}
          >
            Retry
          </Button>
        }
      >
        Failed to load Dropbox folders: {error}
      </Alert>
    );
  }

  if (folders.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        No folders match your current filters. Try adjusting your search or path
        filter.
      </Alert>
    );
  }

  return (
    <List>
      {folders.map((folder: any, index: any) => (
        <React.Fragment key={folder._id || index}>
          <ListItem disablePadding>
            <ListItemButton
              sx={{ borderRadius: 0, gap: 2 }}
              onClick={() => onFolderClick(folder)}
            >
              <ListItemIcon>
                <FileIcon fileName={folder.name} type={folder.type} />
              </ListItemIcon>
              <ListItemText
                primary={
                  isAdmin
                    ? folder.name || folder.path || "Unnamed Folder"
                    : folder.displayName || folder.name || "Unnamed Folder"
                }
                secondary={
                  <Box>
                    {/* {folder.path && (
                      <Typography variant="body2" color="text.secondary">
                        Path: {folder.path}
                      </Typography>
                    )} */}
                    {/* {folder.lastModified && (
                      <Typography variant="body2" color="text.secondary">
                        Last Modified:{" "}
                        {new Date(folder.lastModified).toLocaleDateString()}
                      </Typography>
                    )} */}
                    {/* {folder.size && (
                      <Typography variant="body2" color="text.secondary">
                        Size: {folder.size} items
                      </Typography>
                    )} */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        // alignItems: "center",
                        gap: 1,
                        // mt: 1,
                      }}
                    >
                      {/* {folder.updated_at && (
                        <Typography variant="body2" color="text.secondary">
                          Updated:{" "}
                          {new Date(folder.updated_at).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </Typography>
                      )} */}

                      {/* {folder.type !== "file" &&
                        "isEmpty" in folder &&
                        folder.isEmpty && (
                          <Chip
                            label="Empty"
                            size="small"
                            color="secondary"
                            variant="outlined"
                          />
                        )} */}
                      {isAdmin && (
                        <Typography
                          sx={{
                            "& span": { color: "black" },
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          Client Display Name:{" "}
                          <span>
                            {folder.displayName || folder.name || "N/A"}
                          </span>
                        </Typography>
                      )}
                      {isAdmin &&
                        folder.assignedProjects &&
                        folder.assignedProjects.length > 0 && (
                          <Box sx={{ display: "flex", gap: 1 }}>
                            {folder.assignedProjects.map((project: any) => (
                              <Chip
                                // sx={{ mt: 1 }}
                                key={project.id || project._id}
                                label={
                                  project.name ||
                                  project.project_name ||
                                  `Project ${project.id}`
                                }
                                size="small"
                                color="success"
                                variant="outlined"
                              />
                            ))}
                          </Box>
                        )}
                    </Box>
                  </Box>
                }
              />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip
                  label={folder.type === "file" ? "File" : "Folder"}
                  size="small"
                  color={folder.type === "file" ? "info" : "primary"}
                  variant="outlined"
                />
                {isAdmin && (
                  <IconButton
                    edge="end"
                    aria-label="settings"
                    onClick={(event) => onSettingsClick(event, folder)}
                    size="small"
                  >
                    <SettingsIcon />
                  </IconButton>
                )}
              </Box>
            </ListItemButton>
          </ListItem>
          {index < folders.length - 1 && <Divider sx={{ m: "0 10px" }} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default FolderList;
